import React from "react";
import { Avatar, Box, Break, Button, Card, Grid, Icon, InputCheckbox, InputText, Link, Modal, Picture, Text } from "~/components-shared";
import moment from "moment";
import styled, { css, useTheme } from "styled-components";
import lists from "~/lib/lists";
import StyledIcon from "~/components/StyledIcon";
import Markdown from "~/components/Markdown";
import Collapsable from "~/components/Collapsable";
import { RoutesEnum } from "~/types/enums";
const InfoButton = styled(Button)`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;
const StyledMarkdown = styled(Markdown)`
  ${_ref => {
  let {
    $limit
  } = _ref;
  return $limit && css`
      max-height: 1.4em;
      overflow: hidden;
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;

      & > * {
        overflow: hidden;
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    `;
}};
`;
const PendingItemsCard = _ref2 => {
  let {
    widget,
    ...rest
  } = _ref2;
  const {
    total,
    items
  } = widget.data;
  const [open, setOpen] = React.useState(false);
  const [query, setQuery] = React.useState("");
  const theme = useTheme();
  let filteredItems = items;
  const handleClick = url => {
    window.open(url, "_blank");
  };
  const handleMemberClick = id => {
    window.open(`${window.location.origin}${RoutesEnum.MEMBER.replace(":memberId", id)}`, "_blank");
  };
  if (query) {
    filteredItems = items.filter(item => item.name?.toLowerCase().includes(query.toLowerCase()) || item.member.firstName?.toLowerCase().includes(query.toLowerCase()) || item.member.lastName?.toLowerCase().includes(query.toLowerCase()) || item.source?.toLowerCase().includes(query.toLowerCase()));
  }
  const cardItem = function (item) {
    let details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const dayDiff = moment().diff(moment(item.date), "days");
    return /*#__PURE__*/React.createElement(Card, {
      color: "transparent",
      s: {
        p: 0
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      cols: 3,
      gap: 3,
      template: "1fr auto",
      s: {
        mb: 2
      }
    }, /*#__PURE__*/React.createElement(Text, {
      color: "primary",
      weight: "semiBold"
    }, dayDiff === 0 ? "Today" : dayDiff === 1 ? "Yesterday" : `${dayDiff} days`), /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary",
      weight: "semiBold",
      display: "block",
      align: "right"
    }, /*#__PURE__*/React.createElement(Link, {
      onClick: () => handleClick(item.url),
      "data-testid": item.key,
      color: "inherit",
      underline: true
    }, lists.topics.footprintTypes.names[item.type]), " ", "in", " ", /*#__PURE__*/React.createElement(Picture, {
      width: "1rem",
      height: "1rem",
      display: "inline-block",
      border: "squared",
      s: {
        mb: -0.5
      },
      src: lists.common.apps.logos(theme)[item.source]
    }), " ", lists.topics.footprintSources.names[item.source], " for", " ", details ? /*#__PURE__*/React.createElement(Link, {
      onClick: () => handleMemberClick(item.member.id),
      color: "textSecondary",
      underline: true
    }, item.member.firstName, " ", item.member.lastName) : /*#__PURE__*/React.createElement(Link, {
      onClick: () => handleMemberClick(item.member.id),
      color: "textSecondary",
      underline: false
    }, /*#__PURE__*/React.createElement(Avatar, {
      size: 5,
      user: item.member,
      "data-tooltip-id": "general-tooltip",
      style: {
        cursor: "pointer",
        verticalAlign: "middle"
      },
      s: {
        mt: -1
      },
      "data-tooltip-content": `${item.member.firstName} ${item.member.lastName}`
    })))), /*#__PURE__*/React.createElement(Grid, {
      cols: 3,
      gap: 3,
      template: "1rem 1fr"
    }, /*#__PURE__*/React.createElement(InputCheckbox, {
      s: {
        mt: -2
      }
    }), details ? /*#__PURE__*/React.createElement(Collapsable, null, /*#__PURE__*/React.createElement(StyledMarkdown, {
      linkColor: "primary",
      $limit: false,
      fontSize: 4,
      text: item.name
    })) : /*#__PURE__*/React.createElement(StyledMarkdown, {
      linkColor: "primary",
      $limit: true,
      fontSize: 4,
      text: item.name
    })));
  };
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Box, {
    align: "end",
    s: {
      mb: 5
    },
    gap: 3
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 15,
    lineHeight: 15
  }, total), /*#__PURE__*/React.createElement(Text, {
    element: "h5",
    fontSize: 5,
    lineHeight: 6,
    weight: "semiBold",
    display: "inline"
  }, "PENDING", /*#__PURE__*/React.createElement("br", null), "ITEMS")), items.length ? items.slice(0, 3).map((item, index) => /*#__PURE__*/React.createElement(React.Fragment, null, index !== 0 && /*#__PURE__*/React.createElement(Break, {
    s: {
      my: 1
    }
  }), cardItem(item))) : /*#__PURE__*/React.createElement(Grid, {
    cols: 1,
    justify: "center",
    s: {
      mt: 8
    }
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "successOutline",
    color: "translucentSuccess"
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "semiBold",
    display: "block",
    s: {
      mt: 6
    },
    align: "center",
    style: {
      maxWidth: "250px"
    }
  }, "No identified pending items")), items.length > 3 && /*#__PURE__*/React.createElement(Box, {
    justify: "end",
    s: {
      mt: 2
    }
  }, /*#__PURE__*/React.createElement(Link, {
    color: "primary",
    fontSize: 4,
    onClick: () => setOpen(true)
  }, "See all", /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    s: {
      ml: 1,
      mt: -0.5
    }
  }))), /*#__PURE__*/React.createElement(InfoButton, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Info",
    color: "translucentPrimary",
    display: "inline",
    fontSize: 3,
    lineHeight: 3,
    s: {
      p: 1,
      ml: 2
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 4,
    src: "infoOutline"
  })), /*#__PURE__*/React.createElement(Modal, {
    open: open
  }, /*#__PURE__*/React.createElement(Modal.Body, {
    title: "Pending Items",
    minHeight: "500px",
    onClose: () => setOpen(false),
    maxWidth: "768px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(InputText, {
    value: query,
    onChange: value => setQuery(value),
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "search",
      s: {
        mr: 2
      }
    }),
    placeholder: "Search items...",
    s: {
      mb: 5
    },
    clearButton: true
  }), filteredItems.length ? filteredItems.map((item, index) => /*#__PURE__*/React.createElement(React.Fragment, null, index !== 0 && /*#__PURE__*/React.createElement(Break, {
    s: {
      my: 1
    }
  }), cardItem(item, true))) : /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    align: "center",
    weight: "semiBold",
    fontSize: 4,
    s: {
      my: 5
    }
  }, "No Items found")))));
};
export default PendingItemsCard;